import { render, staticRenderFns } from "./StockKittingForm.vue?vue&type=template&id=28f514a1&scoped=true&"
import script from "./StockKittingForm.vue?vue&type=script&lang=js&"
export * from "./StockKittingForm.vue?vue&type=script&lang=js&"
import style0 from "./StockKittingForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StockKittingForm.vue?vue&type=style&index=1&id=28f514a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f514a1",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QBtn,QIcon,QTooltip,QPopupProxy,QItem,QCardActions,QBtnDropdown,QExpansionItem,QItemSection,QBadge,QBanner,QInput,QDate,QTime,QSelect,QList,QItemLabel,QChip,QAvatar,QImg,QInnerLoading,QSpinnerGears,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QBtn,QIcon,QTooltip,QPopupProxy,QItem,QCardActions,QBtnDropdown,QExpansionItem,QItemSection,QBadge,QBanner,QInput,QDate,QTime,QSelect,QList,QItemLabel,QChip,QAvatar,QImg,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
